import type { EditorTool } from '../../sim/map/index.ts';

export type EditorToolDef = {
  tool: EditorTool;
  label: string;
  shortcut: string;
  menu: 'terrain' | 'water' | 'race' | null;
};

export const EDITOR_TOOL_DEFS: readonly EditorToolDef[] = [
  { tool: 'select', label: 'Select', shortcut: 'V', menu: null },
  { tool: 'hand', label: 'Hand', shortcut: 'H', menu: null },
  { tool: 'scale', label: 'Scale', shortcut: 'S', menu: null },
  { tool: 'rotate', label: 'Rotate', shortcut: 'Q', menu: null },
  { tool: 'draw-island', label: 'Draw island', shortcut: 'I', menu: 'terrain' },
  { tool: 'draw-rock', label: 'Draw rock', shortcut: 'R', menu: 'terrain' },
  { tool: 'draw-terrace', label: 'Draw terraces', shortcut: 'L', menu: 'terrain' },
  { tool: 'draw-water', label: 'Draw shallow water', shortcut: 'W', menu: 'water' },
  { tool: 'place-checkpoint', label: 'Place checkpoint', shortcut: 'C', menu: 'race' },
  { tool: 'edit-start-area', label: 'Start area', shortcut: 'T', menu: 'race' },
  { tool: 'edit-park-area', label: 'Park area', shortcut: 'K', menu: 'race' },
  { tool: 'draw-route', label: 'Draw route', shortcut: 'O', menu: null },
  { tool: 'place-prop', label: 'Place prop', shortcut: 'P', menu: 'terrain' },
  { tool: 'erase-prop', label: 'Erase prop', shortcut: 'X', menu: 'terrain' },
];

export const RAIL_GROUPS: ReadonlyArray<readonly EditorTool[]> = [
  ['select', 'hand'],
  ['scale', 'rotate'],
  ['draw-island', 'draw-rock', 'draw-terrace'],
  ['draw-water'],
  ['place-prop', 'erase-prop'],
  ['place-checkpoint', 'edit-start-area', 'edit-park-area', 'draw-route'],
];

export function toolDef(tool: EditorTool): EditorToolDef {
  const found = EDITOR_TOOL_DEFS.find((entry) => entry.tool === tool);

  if (!found) {
    throw new Error(`Unknown editor tool: ${tool}`);
  }

  return found;
}

export function toolsInMenu(
  menu: Exclude<EditorToolDef['menu'], null>,
): readonly EditorToolDef[] {
  return EDITOR_TOOL_DEFS.filter((entry) => entry.menu === menu);
}
